import dayjs from 'dayjs';
import { AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Button } from '../../../../../../components/button/button';
import { Chip } from '../../../../../../components/chip/chip';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { DeleteModal } from '../../../../../../features/delete-modal/delete-modal';
import { RestoreModal } from '../../../../../../features/restore-modal/restore-modal';
import { Table } from '../../../../../../features/table/table';
import { CompanyAdminsCreateModal } from './company-admins-create-modal/company-admins-create-modal';
import s from './company-admins.module.css';
import { adminRecord } from './helpers';
import { useCompanyAdmins } from './use-company-admins';

export const CompanyAdmins = () => {
  const {
    t,
    addQueryParams,
    handleCloseModal,
    handleOpenModal,
    isOpen,
    restoreAdmin,
    deleteAdmin,
    list,
    branches,
    getLocale,
    managerProfile,
    isLoadingFetch,
  } = useCompanyAdmins();

  return (
    <>
      <div className={s.title}>
        <h3>{t('Администраторы компании')}</h3>
        {managerProfile?.role === 'admin_head' && (
          <Button size="lg" onClick={() => handleOpenModal()}>
            <AiOutlinePlus />
            <span className="hide__S hide__M">{t('Добавить администратора')}</span>
          </Button>
        )}
      </div>

      <Table
        isLoading={isLoadingFetch}
        frontPagination
        cols={{
          name: { label: t('Имя') },
          role: { label: t('Роль') },
          branches: { label: t('Филиалы') },
          created_at: { label: t('Добавлен') },
          actions: { label: t('Действия') },
        }}
        rows={list?.map((item) => {
          const adminBranches = branches?.filter((branch) => item.branches?.includes(branch.id));

          const isEditable = managerProfile?.id !== String(item.id);
          const actions = item.is_deleted ? (
            <IconButton
              tooltip={t('Восстановить')}
              variant="secondary"
              size="sm"
              onClick={() =>
                addQueryParams({
                  restoreId: String(item.id),
                  restoreName: getLocale(item.name),
                })
              }
            >
              <TbRestore />
            </IconButton>
          ) : (
            managerProfile?.role === 'admin_head' && (
              <div className={s.actions}>
                <IconButton
                  tooltip={t('Редактировать')}
                  size="sm"
                  variant="secondary"
                  onClick={() => handleOpenModal({ adminId: item.id! })}
                >
                  <AiOutlineEdit />
                </IconButton>
                {!item.is_deleted && (
                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    onClick={() =>
                      addQueryParams({
                        deleteId: String(item.id),
                        deleteName: getLocale(item.name),
                        deletePrefix: 'admin',
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                )}
              </div>
            )
          );
          return {
            name: (
              <span style={{ opacity: item.is_deleted ? 0.5 : 1 }}>{`${getLocale(
                item.name,
              )} ${getLocale(item.surname)}`}</span>
            ),
            role: t(adminRecord[item.role!]),
            branches: !!adminBranches?.length && (
              <ul className={s.branches}>
                {adminBranches?.map((branch) => (
                  <Chip key={branch.id} variant="info">
                    {getLocale(branch.name)}
                  </Chip>
                ))}
              </ul>
            ),
            created_at: item.created_at ? dayjs(item.created_at).format('DD.MM.YYYY') : '',
            actions: isEditable && actions,
          };
        })}
      />

      {managerProfile?.role === 'admin_head' && (
        <>
          <DeleteModal onSubmit={deleteAdmin} prefix="admin" />
          <RestoreModal onSubmit={restoreAdmin} />
          {isOpen && <CompanyAdminsCreateModal onClose={() => handleCloseModal(['adminId'])} />}
        </>
      )}
    </>
  );
};
